<div aria-hidden="true" class="font-preload">
  <!-- Try to load the font and it's corresponding italic version -->
  <ng-container *ngFor="let fontStyleSheet of fontStyleSheets">
    <span
      class="preloaded-text"
      [style.font-family]="fontStyleSheet?.fontFamily"
      [style.font-weight]="fontStyleSheet?.fontWeight"
      [style.font-style]="'normal'">
      {{ preloadText }}
    </span>
    <span
      class="preloaded-text"
      [style.font-family]="fontStyleSheet?.fontFamily"
      [style.font-weight]="fontStyleSheet?.fontWeight"
      [style.font-style]="'italic'">
      {{ preloadText }}
    </span>
  </ng-container>
</div>
